const isRecord = (value: unknown): value is { [key: string]: unknown } => {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

const getErrorMessage = (
  path: string,
  error?: { [key: string]: unknown } | null
): string | undefined => {
  if (!isRecord(error)) return undefined

  // Handle dot-notation paths like 'left.name' or 'right.value'
  const pathParts = path.split('.')
  let current: { [key: string]: unknown } = error

  // Navigate through the nested structure
  for (const part of pathParts) {
    const nextValue = current[part]
    if (isRecord(nextValue)) {
      current = nextValue
    } else {
      return undefined
    }
  }

  // Extract message if it exists
  if ('message' in current && typeof current.message === 'string') {
    return current.message
  }

  return undefined
}

export const getComparisonErrorMessages = (error?: { [key: string]: unknown } | null) => {
  return {
    leftMessage: getErrorMessage('left.name', error),
    operatorMessage: getErrorMessage('operator', error),
    rightMessage: getErrorMessage('right.value', error),
  }
}

